import React from 'react'

const OrderShimmer = () => {
    return (
        <div className=''>
            <p className='my-4 h-4 bg-gray-200 w-full'></p>
            <p className='my-4 h-4 bg-gray-200 w-full'></p>
            <p className='my-4 h-4 bg-gray-200 w-full'></p>
            <p className='my-4 h-4 bg-gray-200 w-full'></p>
        </div>
    )
}

export default OrderShimmer